/*

sohel  10/12/2022 2700271704 Triggers ,Trigger Group ->Added breadcrumbs,label changes,pagination changes
sohel  10/15/2022 2700271704 Triggers -> Added Code Comments
sohel  10/17/2022 2700271704 Triggers Action and Rule Group Fixed Reset Issue
Raghu 10/28/2022 2700271704 Button styling changes and fields alignment fixes
Prakash 10/30/2022  2700271704 Aligned Text Fields.
Sohel 11/17/2022 2700271704 fixed duplicate loader issue.
saikrishna 11/17/2022 2700271704 render the components based on select action ADDNOTE.
Ravi 11/17/2022 2700271704  Render options of dropDown value
Sai krishna 11/17/2022 2700271704 Action dropdown -- Dynamically rendered fields.
Sai krishna 11/17/2022 2700271704 Action dropdown -- Validation bug fixes.
Sai Maheshwar 11/20/2022 2700271704 fixed add action bugs and added validations
Sai Maheshwar 11/20/2022 2700271704 fixed cancelCode validations
Sohel 11/21/2022 2700271704 field update group dropdown value changes
Sai Maheshwar 11/21/2022 2700271704 fixed window  and field payload issue
Sai Maheshwar 11/21/2022 2700271704 fixed wait date payload issue
Dilip 11/22/2022 2700271704 added required validation to action dropdown
Sai Maheshwar 11/22/2022 2700271704 removed unwanted payload for untieRoute
Sai Maheshwar 11/22/2022 2700271704 renamed action codes
Sohel 11/23/2022 2700271704 fixed action reset issue
akhila 11/24/2022 2700271704 fixed action bug
Sohel 12/03/2022 2700271704 Triggers Alter Custom window changes
Sai Maheshwar 12/08/2022 2700271704 Fixed Alter fields on account payload  issue
Raghu 12/17/2022 2700271704 Trigger Actions Popup Button Alignment Fixes
Ashraf 01/03/2023 2700271704 renamed disposition to status
sai krishna  1/3/2023  2700271704 formula rule changed to data calculatio0ns
kavyareddy 01/04/2023 2700271704 Fixed label issues for waitdays
Akhila 01/20/2023 2700271704 bugFixed unsaved changes issue
Akhila 01/30/2023 2700271704 bugFixed Validation rename in status Field
Akhila 01/31/2023 2700271704 bug fixed while Edit prePopulation issue in canceCode field
Raghu 02/22/2023 2700271704 added new class for input fields and buttons
Raghu 03/01/2023 2700271704 fixed new ui alignments
phaneendra 03/16/23 2700271704 implemented any one of Value or Data calculation
Sohel 03/16/2023 2700271704 change Field Value Props
Sohel 01/31/2023 2701334326 Action Dropdown Changes
Sohel 01/31/2023 2701334326 added Stop Letter and request Letter Functionality
Akhila 04/06/2023 2701334326 Added date field in letter request and validation
Sohel 04/07/2023 2701334326 Fixed Date Field Issue
Sohel 04/13/2023 2701334326 Fixed Validation Issue and Added Untie Action
Prakash 16/05/2023 2701334326 Fixed specing issue in tab view
Sohel 05/24/2023 2701334326 Fixed Start Date Issue
Sohel 06/13/2023 2701334326 Added Date Stamp popup
Prakash 14/04/2023 2701334326 fixed  alignments issues
Sohel 06/13/2023 2701334326 Changed Validation Message
Sohel 06/14/2023 2701334326 Fixed Repository name populate issue
Sohel 06/16/2023 2701334326 Fixed Data Calculation Reset Issue
Sohel 09/30/2023 2701334326 Tie and UnTie Payload Changes
Dilip-pds 10/31/2023 2701334326 added field based on Add/Remove Billing Indicator
*/
import * as Yup from 'yup';
import {Grid, Button, FormHelperText} from '@material-ui/core';
import {ArrowBack} from '@material-ui/icons';
import {Alert} from '@material-ui/lab';
import {Form, Formik} from 'formik';
import React, {useEffect, useState, useContext, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import moment from 'moment';
import {
  SetActionFormData as setActionFormData,
  fetchUserDefinedFields,
} from '../../../../redux/reducers/EventTactics/EventTactics';
import ErrorBoundaryForComponents from '../../../../util/ErrorBoundaryForComponents';
import FormulaSearchContainer from './FormulaRuleGroupSearch';
// import GetCustomFields from './GetCustomFields';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import {CLOSURE_CODE, DISPOSITION_CODE} from '../../../../constants/Lookup';
import AddUserDefinedNote from './ActionsFields/AddUserDefinedNote';
import UpdateFieldsOnAccount from './ActionsFields/UpdateFieldsOnAccount';
import ChangeDisposition from './ActionsFields/ChangeDisposition';
import UntieFromRoute from './ActionsFields/UntieFromRoute';
import ChangeWaitDate from './ActionsFields/ChangeWaitDate';
import UpdateUserDefined from './ActionsFields/UpdateUserDefined';
import GuiAutoComplete from '../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../components/FormComponents/GuiTextField';
import RequestALetter from './ActionsFields/RequestALetter';
import {fetchAllLetterCode} from '../../../../redux/reducers/LetterMaintainance/NewLetterMaintenance';
import StopLetter from './ActionsFields/StopLetter';
import DeleteTableRecordPopup from '../../../../util/DeleteTableRecordPopup';
import BillingIndicator from './ActionsFields/BillingIndicator';

// const useStyles = makeStyles((theme) => ({
//   goBackBtn: {
//     padding: '6px 12px',
//     color: '#320469',
//     marginBottom: '10px',
//   },
// }));
const stopLetterDropdown = [
  {key: 'Y', value: 'Yes'},
  {key: 'N', value: 'No'},
];

const actionCodes = {
  changeDisposition: 'ALTRDISP',
  addUserdefinedNote: 'ADDNOTE',
  updateFieldsOnAccount: 'ALTRFLDS',
  userDefinedWindow: 'ALTRUDW',
  changeWaitDate: 'ALTWTDTE',
  untieAccountFromRoute: 'UNTIERTE',
  requestALetter: 'REQLTR',
  stopLetter: 'STPLTR',
  tieAccount: 'TIEACCT',
  addBillingIndicator: 'ADDBLIND',
  removeBillingIndicator: 'REMBLIND',
};
const currentDate = `${moment(new Date()).format('MM/DD/YYYY')}`;
const actionsInitialValues = {
  [actionCodes.addUserdefinedNote]: {
    actionId: 0,
    params: {
      applyTo: '',
      ruleGroup: '',
      noteToAdd: '',
    },
  },
  [actionCodes.changeDisposition]: {
    actionId: 0,
    params: {
      applyTo: 'R',
      disposition: '',
      waitDate: '',
      ruleGroup: '',
      cancelCode: '',
      overRide: 'N',
      daysToWait: '',
      updateDateBy: 'Wait Date',
    },
  },
  [actionCodes.changeWaitDate]: {
    actionId: 0,
    params: {
      applyTo: 'R',
      ruleGroup: '',
      waitDate: '',
      waitDays: '',
      updateDateBy: 'Wait Date',
    },
  },
  [actionCodes.untieAccountFromRoute]: {
    actionId: 0,
    params: {
      applyTo: 'A',
    },
  },
  [actionCodes.tieAccount]: {
    actionId: 0,
    params: {
      applyTo: 'A',
    },
  },
  [actionCodes.updateFieldsOnAccount]: {
    actionId: 0,
    params: {
      applyTo: '',
      fieldUpdateGroup: '',
    },
  },
  [actionCodes.userDefinedWindow]: {
    actionId: 0,
    params: {
      applyTo: '',
      window: null,
      field: '',
      ruleGroup: '',
      numberOfDays: '',
      dateStamp: '',
      fieldValue: '',
    },
  },
  [actionCodes.requestALetter]: {
    actionId: 0,
    params: {
      applyTo: '',
      letterCode: '',
      date: currentDate,
    },
  },
  [actionCodes.stopLetter]: {
    actionId: 0,
    params: {
      applyTo: '',
      stopPL95: '',
      stopCheckWriter: '',
    },
  },
  [actionCodes.addBillingIndicator]: {
    actionId: 0,
    params: {
      applyTo: '',
      billingIndicator: '',
      dataCalculation: '',
      groupId:'',
    },
  },
  [actionCodes.removeBillingIndicator]: {
    actionId: 0,
    params: {
      applyTo: '',
      billingIndicator: '',
      dataCalculation: '',
      groupId:'',
    },
  },
};

const AddAction = ({
  setSearchData,
  searchData,
  handleClose,
  setActionTableData,
  handleAddActionDialog,
  actionTableData,
  editActionOpen,
  handleDirty,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const {
    eventTacticsActionsList,
    actionFormData,
    dispositionDropDown,
    userDefinedWindowData,
    userDefinedFieldsData,
    allBillingIndicator,
  } = useSelector(({addEventTactic}) => addEventTactic);
  const {allGroupCode} = useSelector(({accountUpdateGroup}) => accountUpdateGroup);
  const [showSearch, setShowSearch] = useState(false);
  const [actionBasedInitialValues, setActionBasedInitialValues] = useState({
    action: null,
    // updateDateBy: "Wait Date",
  });
  const [actionReset, setActionReset] = useState(false);
  //   const [actionValue, setActionValue]
  const [isDateStamp, setIsDateStamp] = useState(false);
  const {allLetterCode} = useSelector(({newLetterMaintenance}) => newLetterMaintenance);
  const formRef = useRef();
  const updateWindowRef = useRef(false);
  const handleDateStampClose = () => {
    setIsDateStamp(false);
  };
  console.log({actionFormData},"actionFormDataactionFormData")
  useEffect(() => {
    if (actionFormData.action) {
      const newInitialValues = {action: actionFormData.action, ...actionFormData.params};
      if (newInitialValues['disposition']) {
        newInitialValues['disposition'] = dispositionDropDown[DISPOSITION_CODE].filter((code) => {
          return code?.valueCode === actionFormData?.params?.disposition;
        })[0];
      }
      if (newInitialValues['cancelCode']) {
        newInitialValues['cancelCode'] = dispositionDropDown[CLOSURE_CODE].filter((code) => {
          return code?.valueCode === actionFormData?.params?.cancelCode;
        })[0];
      }
      if (newInitialValues['fieldUpdateGroup']) {
        newInitialValues['fieldUpdateGroup'] = allGroupCode.filter(
          (el) => el?.groupCode === actionFormData?.params?.fieldUpdateGroup,
        )[0];
      }
      if (newInitialValues['letterCode']) {
        newInitialValues['letterCode'] = allLetterCode.filter(
          (el) => el?.letterCode === actionFormData?.params?.letterCode,
        )[0];
      }
      if (newInitialValues['stopCheckWriter']) {
        newInitialValues['stopCheckWriter'] = stopLetterDropdown.filter(
          (el) => el?.key === actionFormData?.params?.stopCheckWriter,
        )[0];
      }
      if (newInitialValues['stopPL95']) {
        newInitialValues['stopPL95'] = stopLetterDropdown.filter(
          (el) => el?.key === actionFormData?.params?.stopPL95,
        )[0];
      }
      if (newInitialValues['field']) {
        newInitialValues['field'] = updateWindowRef.current ?
          formRef?.current?.values?.field : userDefinedFieldsData?.filter((el) => {
            return el?.fieldName === actionFormData?.params?.field;
          })[0]
      }
      if (newInitialValues['value']) {
        newInitialValues['value'] = updateWindowRef.current ?
          formRef?.current?.values?.value :
          actionFormData?.params?.value;
      }
      if (newInitialValues['ruleGroup']) {
        newInitialValues['ruleGroup'] = updateWindowRef.current ?
          formRef?.current?.values?.ruleGroup :
          actionFormData?.params?.ruleGroup;
      }
      if (newInitialValues['window']) {
        console.log(userDefinedWindowData,"userDefinedWindowData")
        newInitialValues['window'] = userDefinedWindowData?.filter((el) => {
          return el?.dataRepositoryId == actionFormData?.params?.repositoryId;
        })[0];
        // dispatch(fetchUserDefinedFields(newInitialValues["window"]));
      }
      if (newInitialValues['billingIndicator']) {
        newInitialValues['billingIndicator'] = allBillingIndicator?.filter((code) => {
          return code?.billingIndicatorNumber === actionFormData?.params?.billingIndicator;
        })[0];
      }
      setActionBasedInitialValues({
        ...newInitialValues,
        window: updateWindowRef.current ?
          formRef?.current?.values?.window :
          userDefinedWindowData?.filter((el) => {
            return el?.dataRepositoryId == actionFormData?.params?.repositoryId;
          })[0],
      });
    }
  }, [
    actionFormData,
    userDefinedWindowData,
    userDefinedFieldsData,
    allGroupCode,
    actionReset,
    allLetterCode,
    allBillingIndicator,
  ]);
  useEffect(() => {
    if (actionFormData.action) {
      const newInitialValues = {action: actionFormData.action, ...actionFormData.params};

      if (newInitialValues['window']) {
        newInitialValues['window'] = userDefinedWindowData?.filter((el) => {
          return el?.dataRepositoryId == actionFormData?.params?.repositoryId;
        })?.[0]?.repositoryName;
        newInitialValues['window'] && dispatch(fetchUserDefinedFields(newInitialValues['window']));
      }
    }
  }, [userDefinedWindowData]);
  let initialValues = {
    action: null,
  };

  initialValues = actionBasedInitialValues;

  const shape = {
    action: Yup.object().nullable().required('Action is required'),
    applyTo:
      ![
        actionCodes.changeDisposition,
        actionCodes.changeWaitDate,
        actionCodes.untieAccountFromRoute,
        actionCodes.tieAccount,
      ]?.includes(initialValues?.action?.valueCode) &&
      Yup.string().required('Apply To is required').nullable(),
    overRide:
      initialValues?.action?.valueCode === actionCodes.changeDisposition &&
      Yup.string().required('Override is required').nullable(),
    disposition:
      initialValues?.action?.valueCode === actionCodes.changeDisposition &&
      Yup.object().required('Status is required').nullable(),
    cancelCode:
      initialValues?.action?.valueCode === actionCodes.changeDisposition &&
      Yup.object()
        .nullable()
        .test('cancelCode', 'Cancel code is required', (val, context) => {
          if (context.parent?.disposition?.valueCode !== '9000') {
            return true;
          } else if (!Boolean(val)) {
            return false;
          } else {
            return true;
          }
        }),
    changeDisposition:
      initialValues?.action?.valueCode === actionCodes.changeDisposition &&
      Yup.string().test(
        'change disposition',
        'Any of Wait Date, Fixed Wait Date, Data Calculation are required',
        (val, formValues) => {
          const bothValPresent = [
            formValues?.parent?.daysToWait,
            formValues?.parent?.waitDate,
            formValues?.parent?.ruleGroup,
          ].filter(Boolean);
          if (bothValPresent.length === 0) {
            return true;
          } else if (bothValPresent.length > 1) {
            return false;
          } else {
            return true;
          }
        },
      ),
    changeWaitDate:
      initialValues?.action?.valueCode === actionCodes.changeWaitDate &&
      Yup.string().test(
        'changeWaitDate',
        'Any of Wait Date, Data Calculation or Fixed Wait Date are required',
        function(val, formValues) {
          const bothValPresent = [
            formValues?.parent?.waitDays,
            formValues?.parent?.waitDate,
            formValues?.parent?.ruleGroup,
          ].filter(Boolean);
          const anyoneOneIsPresent =
            formValues?.parent?.waitDays ||
            formValues?.parent?.waitDate ||
            formValues?.parent?.ruleGroup;
          if (anyoneOneIsPresent && bothValPresent.length === 1) {
            return true;
          } else {
            return false;
          }
        },
      ),
    userDefinedWindow:
      initialValues?.action?.valueCode === actionCodes.userDefinedWindow &&
      Yup.string().test(
        'changeWaitDate',
        'Any of Number of Days, Date Stamp or Data Calculation are required',
        function(val, formValues) {
          if (formValues?.parent?.field?.fieldType === 'Date') {
            const bothValPresent = [
              formValues?.parent?.numberOfDays,
              formValues?.parent?.dateStamp,
              formValues?.parent?.ruleGroup,
            ].filter(Boolean);
            const anyoneOneIsPresent =
              formValues?.parent?.numberOfDays ||
              formValues?.parent?.dateStamp ||
              formValues?.parent?.ruleGroup;
            if (anyoneOneIsPresent && bothValPresent.length === 1) {
              return true;
            } else {
              return false;
            }
          } else {
            return true;
          }
        },
      ),
    addNote:
      initialValues?.action?.valueCode === actionCodes.addUserdefinedNote &&
      Yup.string().test(
        'addNote',
        'Any of Data Calculation or Note is required',
        function(val, formValues) {
          const bothValPresent = formValues?.parent?.ruleGroup && formValues?.parent?.noteToAdd;
          if ((formValues?.parent?.ruleGroup || formValues?.parent?.noteToAdd) && !bothValPresent) {
            return true;
          } else {
            return false;
          }
        },
      ),

    fieldUpdateGroup:
      initialValues?.action?.valueCode === actionCodes.updateFieldsOnAccount &&
      Yup.mixed().test('fieldUpdateGroup', 'Field Update group is required', (value) => {
        if (!value?.groupCode) {
          return false;
        } else {
          return true;
        }
      }),
    letterCode:
      initialValues?.action?.valueCode === actionCodes.requestALetter &&
      Yup.mixed().test('letterCode', 'Letter Code is required', (value) => {
        if (!value?.letterCode) {
          return false;
        } else {
          return true;
        }
      }),
    stopPL95:
      initialValues?.action?.valueCode === actionCodes.stopLetter &&
      Yup.mixed().test('stopPL95', 'Stop PL95 is required', (value) => {
        if (!value?.key) {
          return false;
        } else {
          return true;
        }
      }),
    stopCheckWriter:
      initialValues?.action?.valueCode === actionCodes.stopLetter &&
      Yup.mixed().test('stopCheckWriter', 'Stop Check Writer is required', (value) => {
        if (!value?.key) {
          return false;
        } else {
          return true;
        }
      }),
    // ruleGroup:
    //   initialValues?.action?.valueCode === actionCodes.userDefinedWindow &&
    //   Yup.string().test(
    //     "fieldValue",
    //     "Any of Value or Data Calculation  is required",
    //     function (val, formValues) {
    //       let bothValPresent = formValues?.parent?.ruleGroup && formValues?.parent?.fieldValue;
    //       if (
    //         (formValues?.parent?.fieldValue || formValues?.parent?.ruleGroup) &&
    //         !bothValPresent
    //       ) {
    //         return true;
    //       } else {
    //         return false;
    //       }
    //     }
    //   ),
    field:
      initialValues?.action?.valueCode === actionCodes.userDefinedWindow &&
      Yup.object().required('Field Name is required').nullable(),
    window:
      initialValues?.action?.valueCode === actionCodes.userDefinedWindow &&
      Yup.object().required('Repository Name is required').nullable(),
    fieldValue:
      initialValues?.action?.valueCode === actionCodes.userDefinedWindow &&
      Yup.string().test(
        'fieldValue',
        'Any of Value or Data Calculation  is required',
        function(val, formValues) {
          if (formValues?.parent?.field?.fieldType === 'Date') {
            return true;
          } else {
            const bothValPresent = formValues?.parent?.ruleGroup && formValues?.parent?.fieldValue;
            if (
              (formValues?.parent?.fieldValue || formValues?.parent?.ruleGroup) &&
              !bothValPresent
            ) {
              return true;
            } else {
              return false;
            }
          }
        },
      ),
    billingIndicator:
      ['ADDBLIND', 'REMBLIND']?.includes(initialValues?.action?.valueCode) &&
      Yup.mixed().test(
        'billingIndicator',
        'Any of Value or Data Calculation  is required',
        function(val, formValues) {
          const bothValPresent = formValues?.parent?.billingIndicator && formValues?.parent?.dataCalculation;
          if (
            (formValues?.parent?.dataCalculation || formValues?.parent?.billingIndicator) &&
              !bothValPresent
          ) {
            return true;
          } else {
            return false;
          }
        },
      ),
    date:
      initialValues?.action?.valueCode === actionCodes.requestALetter ?
        Yup.date()
          .nullable()
          .test('date', 'Date is required', function(value, ctx) {
            const day = ctx.parent;
            if ([null, undefined]?.includes(day?.date) || !currentDate) {
              return false;
            } else {
              return true;
            }
          })
          .test('date', 'Date cannot be a previous Date', function(value) {
            const sDate = moment(value).format('YYYY-MM-DD');
            if (currentDate > sDate) {
              return false;
            } else {
              return true;
            }
          })
          .typeError('Invalid Date Format') :
        null,
  };
  const schema = Yup.object().shape(shape);
  const handleSubmit = (values) => {
    if (values?.dateStamp && values?.action?.valueCode === 'ALTRUDW') {
      setIsDateStamp(true);
    } else {
      if (Object.keys(actionFormData).length > 0) {
        const rowData = {
          actionId: actionFormData.actionId,
          seqNo: actionFormData.seqNo,
          action: actionFormData.action,
        };
        const params = {...values};
        if ('disposition' in params && params.disposition) {
          params.disposition = params.disposition.valueCode;
        }
        if (params.disposition !== '9000') {
          delete params?.cancelCode;
        }
        if ('cancelCode' in params && params.cancelCode) {
          params.cancelCode = params.cancelCode.valueCode;
        }
        if ('waitDate' in params && params.waitDate) {
          params.waitDate = moment(params.waitDate).format('MM-DD-YYYY');
        }
        if ('dateStamp' in params && params.dateStamp) {
          params.dateStamp = moment(params.dateStamp).format('MM-DD-YYYY');
        }
        if ('fieldUpdateGroup' in params && params.fieldUpdateGroup) {
          params.triggerAccountUpdateGroupId = params.fieldUpdateGroup.triggerAccountUpdateGroupId;
          params.fieldUpdateGroup = params.fieldUpdateGroup.groupCode;
        }
        if ('window' in params && params.window?.dataRepositoryId) {
          params.repositoryId = params.window?.dataRepositoryId;
          params.window = params.window?.repositoryName;
        }
        if ('field' in params && params.field?.fieldId) {
          params.fieldId = params.field?.fieldId;
          params.field = params.field?.fieldName;
        }
        if ('fieldValue' in params && params.fieldValue) {
          params.fieldValue = params.fieldValue;
        }
        if ('billingIndicator' in params && params.billingIndicator) {
          params.billingIndicator = params.billingIndicator?.billingIndicatorNumber;
        }
        if ('letterCode' in params && params.letterCode) {
          params.letterCode = params.letterCode?.letterCode;
        }
        if ('date' in params && params.date) {
          params.date = moment(params.date).format('MM-DD-YYYY');
        }
        if ('stopPL95' in params && params.stopPL95) {
          params.stopPL95 = params.stopPL95?.key;
        }
        if ('stopCheckWriter' in params && params.stopCheckWriter) {
          params.stopCheckWriter = params.stopCheckWriter?.key;
        }
        if(params && params?.dataCalculation?.groupId){
          params.groupId = params.dataCalculation.groupId;
          params.dataCalculation = params.dataCalculation.dataCalculation;
        }
        if(params && params?.ruleGroup?.groupId){
          params.groupId = params.ruleGroup.groupId;
          params.ruleGroup = params.ruleGroup.dataCalculation;
        }
        console.log(params,"params1")
        delete params.action;
        const newActionFormData = [...actionTableData];
        newActionFormData[actionFormData.seqNo - 1] = {...rowData, params};
        setActionTableData(newActionFormData);
        handleAddActionDialog();
      } else {
        const actionPayload = {
          ...actionsInitialValues[values.action.actionCode],
          action: values.action,
        };
        const params = {...values};
        if ('waitDate' in params && params.waitDate) {
          params.waitDate = moment(params.waitDate).format('MM-DD-YYYY');
        }
        if ('dateStamp' in params && params.dateStamp) {
          params.dateStamp = moment(params.dateStamp).format('MM-DD-YYYY');
        }
        if ('disposition' in params && params.disposition) {
          params.disposition = params.disposition.valueCode;
        }
        if ('cancelCode' in params && params.cancelCode) {
          params.cancelCode = params.cancelCode.valueCode;
        }
        if ('fieldUpdateGroup' in params && params.fieldUpdateGroup) {
          params.triggerAccountUpdateGroupId = params.fieldUpdateGroup.triggerAccountUpdateGroupId;
          params.fieldUpdateGroup = params.fieldUpdateGroup.groupCode;
        }
        if ('window' in params && params.window?.dataRepositoryId) {
          params.repositoryId = params.window?.dataRepositoryId;
          params.window = params.window?.repositoryName;
        }
        if ('field' in params && params.field?.fieldId) {
          params.fieldId = params.field?.fieldId;
          params.field = params.field?.fieldName;
        }
        if ('fieldValue' in params && params.fieldValue) {
          params.fieldValue = params.fieldValue;
        }
        if ('billingIndicator' in params && params.billingIndicator) {
          params.billingIndicator = params.billingIndicator?.billingIndicatorNumber;
        }
        if ('letterCode' in params && params.letterCode) {
          params.letterCode = params.letterCode?.letterCode;
        }
        if ('date' in params && params.date) {
          params.date = moment(params.date).format('MM-DD-YYYY');
        }
        if ('stopPL95' in params && params.stopPL95) {
          params.stopPL95 = params.stopPL95?.key;
        }
        if ('stopCheckWriter' in params && params.stopCheckWriter) {
          params.stopCheckWriter = params.stopCheckWriter?.key;
        }
        if(params && params?.dataCalculation?.groupId){
          params.groupId = params.dataCalculation.groupId;
          params.dataCalculation = params.dataCalculation.dataCalculation;
        }
        if(params && params?.ruleGroup?.groupId){
          params.groupId = params.ruleGroup.groupId;
          params.ruleGroup = params.ruleGroup.dataCalculation;
        }
        // if (field.paramType === "window") {
        //         return (obj[v] = values[field["paramName"]].windowCode
        //           ? values[field["paramName"]].windowCode
        //           : "");
        //       }
        //       if (field.paramType === "field") {
        //         return (obj[v] = values[field["paramName"]].fieldName
        //           ? values[field["paramName"]].fieldName
        //           : "");
        //       }
        console.log(params,"params2")
        delete params.action;
        const final = {...actionPayload, params};
        setActionTableData([...actionTableData, {...final}]);
        handleAddActionDialog();
      }
    }
  };
  const handleDateStampSubmit = () => {
    const values = formRef.current?.values;
    if (Object.keys(actionFormData).length > 0) {
      const rowData = {
        actionId: actionFormData.actionId,
        seqNo: actionFormData.seqNo,
        action: actionFormData.action,
      };
      const params = {...values};
      if ('disposition' in params && params.disposition) {
        params.disposition = params.disposition.valueCode;
      }
      if (params.disposition !== '9000') {
        delete params?.cancelCode;
      }
      if ('cancelCode' in params && params.cancelCode) {
        params.cancelCode = params.cancelCode.valueCode;
      }
      if ('waitDate' in params && params.waitDate) {
        params.waitDate = moment(params.waitDate).format('MM-DD-YYYY');
      }
      if ('dateStamp' in params && params.dateStamp) {
        params.dateStamp = moment(params.dateStamp).format('MM-DD-YYYY');
      }
      if ('fieldUpdateGroup' in params && params.fieldUpdateGroup) {
        params.triggerAccountUpdateGroupId = params.fieldUpdateGroup.triggerAccountUpdateGroupId;
        params.fieldUpdateGroup = params.fieldUpdateGroup.groupCode;
      }
      if ('window' in params && params.window) {
        params.window = params.window;
      }
      if ('field' in params && params.field) {
        params.field = params.field.fieldName;
      }
      if ('fieldValue' in params && params.fieldValue) {
        params.fieldValue = params.fieldValue;
      }
      if ('letterCode' in params && params.letterCode) {
        params.letterCode = params.letterCode?.letterCode;
      }
      if ('date' in params && params.date) {
        params.date = moment(params.date).format('MM-DD-YYYY');
      }
      if ('stopPL95' in params && params.stopPL95) {
        params.stopPL95 = params.stopPL95?.key;
      }
      if ('stopCheckWriter' in params && params.stopCheckWriter) {
        params.stopCheckWriter = params.stopCheckWriter?.key;
      }
      delete params.action;
      const newActionFormData = [...actionTableData];
      newActionFormData[actionFormData.seqNo - 1] = {...rowData, params};
      setActionTableData(newActionFormData);
      handleAddActionDialog();
    } else {
      const actionPayload = {
        ...actionsInitialValues[values.action.actionCode],
        action: values.action,
      };
      const params = {...values};
      if ('waitDate' in params && params.waitDate) {
        params.waitDate = moment(params.waitDate).format('MM-DD-YYYY');
      }
      if ('dateStamp' in params && params.dateStamp) {
        params.dateStamp = moment(params.dateStamp).format('MM-DD-YYYY');
      }
      if ('disposition' in params && params.disposition) {
        params.disposition = params.disposition.valueCode;
      }
      if ('cancelCode' in params && params.cancelCode) {
        params.cancelCode = params.cancelCode.valueCode;
      }
      if ('fieldUpdateGroup' in params && params.fieldUpdateGroup) {
        params.triggerAccountUpdateGroupId = params.fieldUpdateGroup.triggerAccountUpdateGroupId;
        params.fieldUpdateGroup = params.fieldUpdateGroup.groupCode;
      }
      if ('window' in params && params.window) {
        params.window = params.window;
      }
      if ('field' in params && params.field) {
        params.field = params.field.fieldName;
      }
      if ('fieldValue' in params && params.fieldValue) {
        params.fieldValue = params.fieldValue;
      }
      if ('letterCode' in params && params.letterCode) {
        params.letterCode = params.letterCode?.letterCode;
      }
      if ('date' in params && params.date) {
        params.date = moment(params.date).format('MM-DD-YYYY');
      }
      if ('stopPL95' in params && params.stopPL95) {
        params.stopPL95 = params.stopPL95?.key;
      }
      if ('stopCheckWriter' in params && params.stopCheckWriter) {
        params.stopCheckWriter = params.stopCheckWriter?.key;
      }
      // if (field.paramType === "window") {
      //         return (obj[v] = values[field["paramName"]].windowCode
      //           ? values[field["paramName"]].windowCode
      //           : "");
      //       }
      //       if (field.paramType === "field") {
      //         return (obj[v] = values[field["paramName"]].fieldName
      //           ? values[field["paramName"]].fieldName
      //           : "");
      //       }
      delete params.action;
      const final = {...actionPayload, params};
      setActionTableData([...actionTableData, {...final}]);
      handleAddActionDialog();
    }
  };
  useEffect(() => {
    dispatch(fetchAllLetterCode());
  }, []);

  return (
    <Formik
      validationSchema={schema}
      initialValues={initialValues}
      onSubmit={handleSubmit}
      enableReinitialize
      innerRef={formRef}
    >
      {(props) => {
        const {
          values,
          setFieldValue,
          touched,
          errors,
          handleBlur,
          dirty,
        } = props;
        handleDirty && handleDirty(dirty);
        let currentErrMesg = '';
        let showValidations = null;
        if (errors?.changeWaitDate) {
          currentErrMesg = errors?.changeWaitDate;
          showValidations = touched.ruleGroup || touched.waitDate || touched.waitDays;
        } else if (errors.addNote) {
          currentErrMesg = errors.addNote;
          showValidations = touched.ruleGroup || touched.noteToAdd;
        } else if (errors.fieldValue) {
          currentErrMesg = errors.fieldValue;
          showValidations = touched.ruleGroup || touched.fieldValue;
        } else if (errors.changeDisposition) {
          currentErrMesg = errors.changeDisposition;
          showValidations = touched.waitDate || touched.ruleGroup || touched.daysToWait;
        } else if (errors.userDefinedWindow) {
          currentErrMesg = errors.userDefinedWindow;
          showValidations = touched.ruleGroup || touched.noOfDays || touched.dateStamp;
        } else if (errors.billingIndicator) {
          currentErrMesg = errors.billingIndicator;
          showValidations = touched.dataCalculation || touched.billingIndicator;
        }
        return (
          <>
            {showSearch ? (
              <>
                <div className="new-standard-textfields form-group ml-3">
                  <Button
                    variant="text"
                    className={`"mb-2" search-btn ${classes.buttonRoot}`}
                    onClick={() => {
                      setShowSearch(false);
                    }}
                  >
                    <ArrowBack className="mr-2" />
                    Go Back
                  </Button>
                </div>
                <FormulaSearchContainer
                  setSearchData={setSearchData}
                  handleClose={handleClose}
                  eventTacticAddRuleGroup={true}
                  searchData={searchData}
                />
              </>
            ) : (
              <div className="col-md-12">
                <Form noValidate>
                  <>
                    <ErrorBoundaryForComponents>
                      <>
                        {showValidations && currentErrMesg && (
                          <Alert className="mb-3" severity="error">
                            {currentErrMesg}
                          </Alert>
                        )}
                        <Grid container spacing={4} className="new-standard-textfields">
                          <Grid item sm={4} className="form-group">
                            <GuiAutoComplete
                              classes={{
                                option: classes.option,
                              }}
                              name="action"
                              id="action"
                              size="small"
                              value={values.action}
                              disabled={editActionOpen}
                              onChange={(e, value, reason) => {
                                setActionBasedInitialValues({
                                  ...actionBasedInitialValues,
                                  ...(actionsInitialValues[value?.valueCode] ?
                                    actionsInitialValues[value?.valueCode]['params'] :
                                    {}),
                                  action: value,
                                });
                                setFieldValue('action', value);
                              }}
                              options={eventTacticsActionsList}
                              getOptionLabel={(option) => {
                                return option && option?.value ? option?.value : '';
                              }}
                              renderInput={(params) => (
                                <div className="select-field">
                                  <GuiTextField
                                    {...params}
                                    className={` ${classes.labelName}`}
                                    required
                                    error={touched.action && errors.action}
                                    variant="outlined"
                                    margin="dense"
                                    InputLabelProps={{shrink: true}}
                                    label="Action"
                                    onBlur={handleBlur}
                                    placeholder="Select Action"
                                  />
                                </div>
                              )}
                            />
                            <FormHelperText error>
                              {touched.action && errors.action && errors.action}
                            </FormHelperText>
                          </Grid>
                          {values?.action?.valueCode === actionCodes.addUserdefinedNote ? (
                            <AddUserDefinedNote {...props} setShowSearch={setShowSearch} />
                          ) : null}
                          {values?.action?.valueCode === actionCodes.updateFieldsOnAccount ? (
                            <UpdateFieldsOnAccount {...props} />
                          ) : null}
                          {values?.action?.valueCode === actionCodes.changeDisposition ? (
                            <ChangeDisposition {...props} setShowSearch={setShowSearch} />
                          ) : null}
                          {values?.action?.valueCode === actionCodes.untieAccountFromRoute ||
                          values?.action?.valueCode === actionCodes.tieAccount ? (
                              <UntieFromRoute {...props} />
                            ) : null}
                          {values?.action?.valueCode === actionCodes.changeWaitDate ? (
                            <ChangeWaitDate {...props} setShowSearch={setShowSearch} />
                          ) : null}
                          {values?.action?.valueCode === actionCodes.userDefinedWindow ? (
                            <UpdateUserDefined
                              {...props}
                              setShowSearch={setShowSearch}
                              updateWindowRef={updateWindowRef}
                            />
                          ) : null}
                          {values?.action?.valueCode === actionCodes.requestALetter ? (
                            <RequestALetter {...props} />
                          ) : null}
                          {values?.action?.valueCode === actionCodes.stopLetter ? (
                            <StopLetter {...props} />
                          ) : null}
                          {['ADDBLIND', 'REMBLIND']?.includes(values?.action?.valueCode) ? (
                            <BillingIndicator {...props} setShowSearch={setShowSearch} />
                          ) : null}
                        </Grid>
                        <div className="row justify-content-center new-standard-textfields">
                          <div>
                            <Button
                              type="button"
                              variant="outlined"
                              className={`mx-1 reset-btn ${classes.buttonRoot}`}
                              onClick={() => {
                                if (editActionOpen) {
                                  setActionReset(!actionReset);
                                  dispatch(setActionFormData({...actionFormData}));
                                  setActionBasedInitialValues({
                                    ...actionFormData,
                                    window: userDefinedWindowData?.filter((el) => {
                                      return el == actionFormData?.params?.window;
                                    })[0],
                                  });
                                  if (
                                    updateWindowRef.current &&
                                    values?.action?.valueCode === actionCodes.userDefinedWindow
                                  ) {
                                    dispatch(
                                      fetchUserDefinedFields(actionFormData?.params?.window),
                                    );
                                  }
                                  updateWindowRef.current = false;
                                } else {
                                  setActionBasedInitialValues({action: null});
                                }
                              }}
                            >
                              Reset
                            </Button>
                            <Button
                              variant="outlined"
                              type="submit"
                              className={`search-btn mx-1 ${classes.buttonRoot}`}
                            >
                              Save
                            </Button>
                          </div>
                        </div>
                      </>
                    </ErrorBoundaryForComponents>
                  </>
                </Form>
                <DeleteTableRecordPopup
                  open={isDateStamp}
                  dialogClose={handleDateStampClose}
                  title="Warning !"
                  value={`The date stamp will be always set to ${
                    values?.dateStamp ? moment(values.dateStamp).format('MM-DD-YYYY') : ''
                  } do you want to continue.`}
                  handleSubmit={handleDateStampSubmit}
                />
              </div>
            )}
          </>
        );
      }}
    </Formik>
  );
};

export default AddAction;
